import React, {useState, useEffect} from 'react';
import {getPlaceNameAll, getPlaceNameHistory, getUsers, addStartend} from '../../../services/MadricService';
import {useNavigate} from 'react-router';
import AddCheckinInfoView from './AddCheckinInfoView';
import {useLocation} from 'react-router-dom';
import Spinner from '../../Spinner/Spinner';

/**
 * Permet d'ajouter un checkin
 * @return {JSX}
 */
function AddCheckinInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  // Liste de taches
  const [taches, setTaches] = useState([]);
  const [week, setWeek] = useState();

  // Permet de savoir si on veut la liste complete de taches ou que l'historique
  const [checkedChantier, setCheckedChantier] = useState(false);

  // Liste de chantier
  const [placeName, setPlaceName] = useState([]);

  const [nbHeures, setNbHeures] = useState(0);

  // Liste d'employers
  const [usernames, setusernames] = useState([{}]);

  // Form du checkin a remplir
  const [form, setForm] = useState({note: '',
    date: getTodayDate(),
    checkin: null,
    checkout: null,
    transport: false,
    employer: null,
    chantier: {},
    extra1: false,
    extra2: false,
    extra3: false,
  });

  const [employerCheckinId, setEmployerCheckinId] = useState({value: localStorage.getItem('id'), label: localStorage.getItem('name')});

  let checkedChantierAfterRender = false;

  const [isLoading, setIsLoading] = useState(false);
  /**
   * Crée une date d'aujourd'hui dans un format que php comprend
   * @return {JSX}
   */
  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    setWeek(location.state.week);
    listUsername();
    fetchPlaces();
  }, []);

  /**
   * Permet d'allez chercher la liste des chantiers
   */
  async function fetchPlaces() {
    if (checkedChantierAfterRender) {
      const res = await getPlaceNameAll();
      setPlaceName(res);
    } else {
      const res = await getPlaceNameHistory();
      setPlaceName(res);
    }
  }

  /**
   * Permet d'allez chercher la liste des users
   */
  async function listUsername() {
    const res = await getUsers();
    setusernames(res);
  }

  // Liste de fonction pour les onChange de chaque input
  const handleChantierCheckBox = () => {
    setCheckedChantier((prevState) => !prevState);
    checkedChantierAfterRender = !checkedChantier;
    fetchPlaces();
  };


  const handleChangeCheckBox = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };

  const handleChange = (event, formValue) => {
    setForm({
      ...form,
      [formValue]: event,
    });

    if (formValue === 'checkin' && form.checkout != null) {
      setNbHeures((parseInt(form.checkout.$H, 10) * 60 + parseInt(form.checkout.$m, 10)) - (parseInt(event.$H, 10) * 60 + parseInt(event.$m, 10)));
    }

    if (formValue === 'checkout' && form.checkin != null) {
      setNbHeures((parseInt(event.$H, 10) * 60 + parseInt(event.$m, 10)) - (parseInt(form.checkin.$H, 10) * 60 + parseInt(form.checkin.$m, 10)));
    }
  };

  const handleNoteChange = (event) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        note: event.target.value,
      };
    });
  };

  const handleDateChange = (event) => {
    setForm((prevNote) => {
      return {
        ...prevNote,
        date: event.target.value,
      };
    });
  };

  const checkinEmployeChange = (event) => {
    setEmployerCheckinId(event);
  };

  /**
   * Permet d'envoyer le formulaire
   * @param {*} event event
   */
  async function handleSubmit(event) {
    const errorsForm = {};

    setForm((prevData) => ({
      ...prevData,
      errorsForm,
    }));

    event.preventDefault();

    if (form.checkout !== null && form.checkin !== null && form.checkout < form.checkin) {
      errorsForm.heure = 'Le checkout le peut pas être plus petit que le checkin.';
    };

    if (Object.keys(form.chantier).length === 0) {
      errorsForm.chantier = 'Le chantier ne peut pas être vide.';
    };

    const currentDate = new Date();
    const currentDayOfWeek = currentDate.getDay();
    const daysToSubtract = currentDayOfWeek + 1;
    const lastSunday = new Date();
    lastSunday.setDate(currentDate.getDate() - daysToSubtract - 7);
    const inputDate = new Date(form.date);

    if (inputDate <= lastSunday || inputDate > currentDate) {
      errorsForm.date = 'La date doit être entre dimanche de la semaine passée et aujourd\'hui';
    };

    if (Object.keys(errorsForm).length > 0) {
      setForm((prevData) => ({
        ...prevData,
        errorsForm,
      }));
    } else {
      let tacheslist;
      if (taches.length === 0 || taches === null || taches === undefined) {
        tacheslist = null;
      } else if (Object.keys(taches[0]).length === 0) {
        tacheslist = null;
      } else {
        tacheslist = taches;
      };

      form.checkinConverted = form.checkin === null ? null : form.checkin.$H + ':' + form.checkin.$m;
      form.checkoutConverted = form.checkout === null? null : form.checkout.$H + ':' + form.checkout.$m;

      setIsLoading(true);
      await addStartend(form, tacheslist, employerCheckinId.value);
      setIsLoading(false);

      navigate('/Checkin', {state: {week}});
    }
  };

  /**
   * Permet de revenir en arrière
   */
  function back() {
    navigate('/Checkin', {state: {week}});
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <AddCheckinInfoView
        handleNoteChange={handleNoteChange}
        handleDateChange={handleDateChange}
        handleSubmit={handleSubmit}
        handleChantierCheckBox={handleChantierCheckBox}
        placeName={placeName}
        taches={taches}
        setTaches={setTaches}
        usernames={usernames}
        form={form}
        nbHeures={nbHeures}
        checkinEmployeChange={checkinEmployeChange}
        employerCheckinId={employerCheckinId}
        handleChangeCheckBox={handleChangeCheckBox}
        handleChange={handleChange}
        back={back} />
    </React.Fragment>
  );
}

export default AddCheckinInfo;
